import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonUi from '@finam/web-ui-kit/Button';
import { useClassName } from '../../uiClassNames';

var Button = function Button(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  var buttonClassName = useClassName('button', className, props.variant);
  return _jsx(ButtonUi, Object.assign({}, props, {
    className: buttonClassName
  }));
};

export default Button;